import React from "react";
import { ArrowUpRight } from "lucide-react";

export default function FeaturedConversations() {
  return (
    <section
      className="border-t border-[var(--eai-border)] bg-[var(--eai-ink)] text-white py-20 lg:py-28 px-6 lg:px-12"
      data-testid="featured-conversations"
    >
      <div className="max-w-[1400px] mx-auto">
        <p className="font-mono-eai text-[11px] uppercase tracking-widest text-[var(--eai-accent)]">
          Featured Conversations
        </p>
        <h2 className="mt-6 font-display text-4xl lg:text-6xl font-bold tracking-tight leading-[1.02] max-w-4xl">
          The Soul in the Machine: A Call for Ethical AI
        </h2>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-8 space-y-6">
            <iframe
              src="https://www.youtube-nocookie.com/embed/nSCzvA8LqkQ?vq=hd1080&hd=1&rel=0&modestbranding=1"
              title="The Soul in the Machine"
              className="w-full aspect-video border border-white/10"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              loading="lazy"
              data-testid="featured-conversations-video"
            />
          </div>

          <div className="lg:col-span-4">
            <p className="text-xl lg:text-2xl leading-relaxed text-white/90 font-display">
              Before AI sovereignty became a mainstream concern, Matthew Kilkenny sat down with Angelique Letizia to explore a single question: <em>can humanity remain fully human in the age of intelligent machines?</em>
            </p>
            <p className="mt-6 text-white/50 font-mono-eai text-sm uppercase tracking-[0.18em]">
              Recorded in 2025. More relevant than ever.
            </p>
            <a
              href="https://www.youtube.com/watch?v=nSCzvA8LqkQ"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="featured-conversations-watch-btn"
              className="mt-10 inline-flex items-center gap-3 px-8 py-5 bg-[var(--eai-accent)] text-black font-bold uppercase tracking-[0.22em] text-[10px] hover:bg-transparent hover:text-[var(--eai-accent)] border border-[var(--eai-accent)] transition-colors duration-200"
            >
              Watch Full Conversation
              <ArrowUpRight size={14} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
